export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\"]',
  product: 'PJ',
  brand: 'VYV',
  apiV2RootUrl: 'https://tst-02.assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://tst-02.assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: 'ab0508f5-e01f-4f79-8db0-5f7c95fd83a4',
  assGarantie:
    'https://saboiartbackofficeso90j.blob.core.windows.net/public/VYV_Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoScriptUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  msalConfig: {
    auth: {
      clientId: '92f47a31-033d-4bf8-b065-db58aaaeb7ce',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri:
        'https://tst-02.assurance-protection-juridique.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-tst-02-back-office/Read.All', 'api://boiard-tst-02-back-office/Write.All'],
    uri: 'https://tst-02.assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://tst-02.assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3970',
};
